import axios from "axios";
import type { RichText } from "@/types";

export interface FlowStudy {
   id: string;
   title: string;
   key: string;
   joiningFlowId: string;
}

export interface FlowResp {
   data: {
      data: FlowData;
   };
   config: object;
}

interface JumpToItem {
   goToSectionId: string;
   conditions: unknown;
}

export interface BlockType {
   id: string;
   title: string;
   allowAnswerResubmission: boolean;
   componentName: string;
   categoryId: string;
}

interface BlockSection {
   id: string;
   label: string;
   blocks: string[];
   goto_section_id: string | null;
}

export interface BlockData {
   id: string;
   blockVersionId: string;
   createdAt: string;
   updatedAt: string;
   type: BlockType;
   componentName: string;
   heading: string;
   subheading: RichText;
   data: any; // this varies based on the block type
   isRequired: boolean;
   versionDiff: string;
   jumpTo: JumpToItem[];
   screenoutImmediately: boolean;
   flowId: string;
   flowVersionId: string;
   localeId: string;
}

export interface FlowData {
   allowPublicResume: boolean;
   anonymousSubmissionsOnly: boolean;
   blockSections: BlockSection[];
   blocks: Array<BlockData>;
   createdAt: string | null;
   description: string | null;
   endRules: object | null; // JSONField
   endSection: object | null; // JSONField.
   flowVersionId: string;
   id: string;
   inclusionCriteria: object | null; // JSONField
   isAdminOnly: boolean;
   isPublic: boolean;
   isPublished: boolean;
   localeId: string;
   lockedById: string | null;
   relevance: object | null; // JSONField
   stageId: string | null;
   study: FlowStudy;
   studyId: string;
   title: string | null;
   updatedAt: string;
   version: number;
}

interface FlowCompletionResp {
   data: {
      data: {
         createdAt: string;
         flowId: string;
         id: string;
         isEligible: boolean;
         lastSubmittedBlockId: string | null;
         localeId: string;
         reachedEndAt: string | null;
         resetAt: string | null;
         resumeCode: string | null;
         screenoutReason: string | null;
         showParticipationResetMessage: boolean;
      };
      token: string;
      endRulesResult: object | null;
   };
   config: object;
}

export default class FlowsApi {
   public static getFlowById = async (id: string): Promise<FlowResp> => {
      const response = await axios.get(`/flows/${id}`);
      return response;
   };

   public static completeFlow = async (flowId: string): Promise<FlowCompletionResp> => {
      const response = await axios.post(`/flows/${flowId}/complete-submission`, null);
      return response;
   };

   public static completeFlowAnonymously = async (
      flowId: string,
      token: string | null = null
   ): Promise<FlowCompletionResp> => {
      const response = await axios.post(`/p/flows/${flowId}/complete-submission`, { token });
      return response;
   };
}
